import React from 'react'
import { numberAddCommas } from 'servos/formValidations'

import GreyBig from './../GreyBig'

class Item extends React.Component {
  render() {
    const {
      title,
      amount,
    } = this.props;

    if (amount == null) {
      return(null)
    }

    return(
      <div className='mb-4'>
        <div className='justify-content-between d-sm-flex'>
          <GreyBig
            size='block'
            grey={ title }
            big={'$' + numberAddCommas(amount) + ' per month.' }
          />
        </div>
      </div>
    )
  }
}

export default Item
